<template>
  <div class="main-visual">
    <img src="/static/img/toppage/lp/mainVisual.png" alt="無制限で見放題!">
    <link-button :link="signupUrl" buttonFace="新規登録" class="btn1" @click="$emit('link', 'subsc1')" />
    <link-button link="/user/login" buttonFace="会員ログイン" design="ghost" class="btn2" @click="$emit('link', 'login')" />
  </div>
</template>

<script>
import LinkButton from '@/utvStore/components/partials/LinkButton'

export default {
  name: 'MainVisual',
  components: {
    LinkButton
  },
  props: {
    signupUrl: {
      type: String,
      default: '',
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";

.main-visual {
  position: relative;
  > img {
    max-width: 100%;
    vertical-align: middle;
  }
  .btn1,
  .btn2 {
    position: absolute;
    top: 73.6%;
    width: 34.666%;
  }
  .btn1 { left: 14.4%; }
  .btn2 { left: 51.4666%; }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Toppage/section/MainVisual.vue